import React from 'react';

export default class Page6 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt ">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p>Set out the elements and describe each one in no more than 15
                                                words.</p>
                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport tablesrink">
                                                <tbody>
                                                <tr>
                                                    <th width="50%" align="left" valign="center"
                                                        className="green_curve ">Element
                                                    </th>
                                                    <th width="50%" align="left" valign="top"
                                                        className="green_curve1">Definition
                                                    </th>
                                                </tr>


                                                <tr>
                                                    <td width="50%" align="left" valign="top"
                                                        className=" sept lightgreen" >
                                                         <textarea className="width-bottom"
                                                                   name="1"
                                                                   value={pageData?.Element?.[1]}
                                                                   onChange={this.props.handleChangePageData('Element')}/>
                                                    </td>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea className="width-bottom"
                                                                  name="1"
                                                                  value={pageData?.Definition?.[1]}
                                                                  onChange={this.props.handleChangePageData('Definition')}/>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td width="50%" align="left" valign="top"
                                                        className=" sept lightgreen" >
                                                         <textarea className="width-bottom"
                                                                   name="2"
                                                                   value={pageData?.Element?.[2]}
                                                                   onChange={this.props.handleChangePageData('Element')}/>
                                                    </td>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea className="width-bottom"
                                                                  name="2"
                                                                  value={pageData?.Definition?.[2]}
                                                                  onChange={this.props.handleChangePageData('Definition')}/>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td width="50%" align="left" valign="top"
                                                        className=" sept lightgreen" >
                                                         <textarea className="width-bottom"
                                                                   name="3"
                                                                   value={pageData?.Element?.[3]}
                                                                   onChange={this.props.handleChangePageData('Element')}/>
                                                    </td>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea className="width-bottom"
                                                                  name="3"
                                                                  value={pageData?.Definition?.[3]}
                                                                  onChange={this.props.handleChangePageData('Definition')}/>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td width="50%" align="left" valign="top"
                                                        className=" sept lightgreen" >
                                                         <textarea className="width-bottom"
                                                                   name="4"
                                                                   value={pageData?.Element?.[4]}
                                                                   onChange={this.props.handleChangePageData('Element')}/>
                                                    </td>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea className="width-bottom"
                                                                  name="4"
                                                                  value={pageData?.Definition?.[4]}
                                                                  onChange={this.props.handleChangePageData('Definition')}/>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td width="50%" align="left" valign="top"
                                                        className=" sept lightgreen" >
                                                         <textarea className="width-bottom"
                                                                   name="5"
                                                                   value={pageData?.Element?.[5]}
                                                                   onChange={this.props.handleChangePageData('Element')}/>
                                                    </td>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea className="width-bottom"
                                                                  name="5"
                                                                  value={pageData?.Definition?.[5]}
                                                                  onChange={this.props.handleChangePageData('Definition')}/>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td width="50%" align="left" valign="top"
                                                        className=" sept lightgreen" >
                                                         <textarea className="width-bottom"
                                                                   name="6"
                                                                   value={pageData?.Element?.[6]}
                                                                   onChange={this.props.handleChangePageData('Element')}/>
                                                    </td>
                                                    <td width="50%" align="left" valign="top"
                                                        className="lightgreen">
                                                        <textarea className="width-bottom"
                                                                  name="6"
                                                                  value={pageData?.Definition?.[6]}
                                                                  onChange={this.props.handleChangePageData('Definition')}/>
                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>


                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
COMMUNICATING COMPLEX THINKING
</span></div>
                                            <div className="border_subtitle">The channel to audience
                                                matrix
                                            </div>
                                            <p>Use the following table to consider your approach to
                                                communicating complex ideas in various
                                                individual or group situations. It is worth working out
                                                which is your preferred approach in order to
                                                build on that.
                                            </p>
                                            <div className="mobile-scroll">
                                                <table width="100%" border="0" cellSpacing="0"
                                                       cellPadding="0" className="ilead_v_sport tablesrink">
                                                    <tbody>
                                                    <tr>
                                                        <th width="25%" align="left" valign="center"
                                                            className="green_curve ">Situation
                                                        </th>
                                                        <th width="25%" align="left" valign="center">1:1
                                                        </th>
                                                        <th width="25%" align="left" valign="center">Small
                                                            Group
                                                        </th>
                                                        <th width="25%" align="left" valign="top"
                                                            className="green_curve1">Large Group
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <td width="25%" align="left" valign="top"
                                                            className="lightgreen"><p><strong>Face to
                                                            Face</strong></p>


                                                        </td>
                                                        <td width="25%" align="left" valign="top"
                                                            className="lightgreen"><p>Very good method
                                                            – allows for non-verbal
                                                            feedback as well as
                                                            verbal. You can use
                                                            this method to check
                                                            understanding and to
                                                            allow the person to
                                                            ask questions, etc.
                                                        </p>
                                                        </td>
                                                        <td width="25%" align="left" valign="top"
                                                            className="lightgreen"><p>Effective method and
                                                            can be supported by
                                                            prior emails/reports
                                                            to allow the group to
                                                            prepare. Important
                                                            to set ground rules
                                                            to control how your
                                                            audience can interact
                                                            with you in terms of
                                                            questions, etc.
                                                            A short PowerPointtype
                                                            presentation can
                                                            be very effective to
                                                            support this.</p>

                                                        </td>
                                                        <td width="25%" align="left" valign="top"
                                                            className="lightgreen"><p>Call the meeting in a
                                                            place where you can set
                                                            out a clear presentation.
                                                            Remember your audience
                                                            is likely to be a mixture of
                                                            S and N types. Start with
                                                            the big picture concept
                                                            before moving on to
                                                            explain details, to cater for
                                                            both types. Use graphics
                                                            to illustrate your concepts
                                                            and tables/graphs for the
                                                            finer detail. Control of your
                                                            audience is essential here
                                                            and you should definitely
                                                            regulate questions. Use of
                                                            follow-up feedback surveys
                                                            can help to assess the
                                                            impact of your ideas.</p>

                                                        </td>
                                                    </tr>


                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.savePageData('Page7')}
                                                     className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}